exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#drift-widget-container { z-index: 4 !important;}\n.v-card__text, .v-card__title {\n  word-break: normal; /* maybe !important  see https://github.com/vuetifyjs/vuetify/issues/9130 */\n}\n.centered {\n  display: table;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n.centered2 {\n  margin-left:auto;\n  margin-right:auto;\n  display: table;\n}\n.clickable {\n  cursor: pointer;\n}\n", ""]);

// exports
